export const getValidationMessage = (r) => {
  const value = r.value;
  const operator = r.operator;

  // Null/notNull operators don't need a value
  if (operator === "null" || operator === "notNull") {
    return null;
  }

  // Check for empty/null/undefined
  if (value === undefined || value === null || value === '') {
    return 'Value cannot be empty';
  }

  // Check if value is a number (or numeric string)
  const numValue = Number(value);
  if (!Number.isNaN(numValue) && typeof value !== 'boolean') {
    if (numValue < 0) {
      return 'Value must be a non-negative number';
    }
    return null;
  }

  const stringValue = String(value);

  // Dangerous SQL injection patterns to reject
  const sqlInjectionPatterns = [
    { pattern: /--/, message: 'SQL comments (--) are not allowed' },
    { pattern: /;/, message: 'Semicolons are not allowed' },
    { pattern: /\/\*/, message: 'Block comments are not allowed' },
    { pattern: /\*\//, message: 'Block comments are not allowed' },
    { pattern: /\bOR\b.*=/i, message: 'SQL keyword "OR" is not allowed' },
    { pattern: /\bAND\b.*=/i, message: 'SQL keyword "AND" is not allowed' },
    { pattern: /\bUNION\b/i, message: 'SQL keyword "UNION" is not allowed' },
    { pattern: /\bSELECT\b/i, message: 'SQL keyword "SELECT" is not allowed' },
    { pattern: /\bDROP\b/i, message: 'SQL keyword "DROP" is not allowed' },
    { pattern: /\bDELETE\b/i, message: 'SQL keyword "DELETE" is not allowed' },
    { pattern: /\bINSERT\b/i, message: 'SQL keyword "INSERT" is not allowed' },
    { pattern: /\bUPDATE\b/i, message: 'SQL keyword "UPDATE" is not allowed' },
    { pattern: /\bEXEC\b/i, message: 'SQL keyword "EXEC" is not allowed' },
    { pattern: /\bEXECUTE\b/i, message: 'SQL keyword "EXECUTE" is not allowed' },
    { pattern: /\bxp_/i, message: 'Extended stored procedures are not allowed' },
    { pattern: /\bsp_/i, message: 'System stored procedures are not allowed' },
    { pattern: /\\x00/, message: 'Null bytes are not allowed' },
    { pattern: /'/, message: 'Single quotes are not allowed' },
    { pattern: /`/, message: 'Backticks are not allowed' },
  ];

  for (const { pattern, message } of sqlInjectionPatterns) {
    if (pattern.test(stringValue)) {
      return message;
    }
  }

  return null;
};

export const validator = (r) => {
  return getValidationMessage(r) === null;
};
